import { render, staticRenderFns } from "./PXSurvey.vue?vue&type=template&id=8a22fb12"
import script from "./PXSurvey.vue?vue&type=script&lang=js"
export * from "./PXSurvey.vue?vue&type=script&lang=js"
import style0 from "./PXSurvey.vue?vue&type=style&index=0&id=8a22fb12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports